import React from "react";
import { useNavigate } from "react-router-dom";
import { 
  FaLandmark, 
  FaCity, 
  FaBuilding, 
  FaArchway, 
  FaMosque, 
  FaUniversity,
  FaSubway
} from "react-icons/fa";
import { FiChevronRight, FiArrowUpRight } from "react-icons/fi";
import "./ExploreRealEstateNew.css";

const ExploreRealEstate = () => {
  const navigate = useNavigate();

  const cities = [
    {
      id: "delhi",
      name: "Delhi / NCR",
      searchParam: "Delhi",
      count: "124,000+ Properties",
      image: "/assets/images/sliderImg/Delhi.jpg",
      icon: <FaLandmark />,
      themeClass: "mgh-city-delhi",
    },
    {
      id: "bangalore",
      name: "Bangalore",
      searchParam: "Bangalore",
      count: "33,000+ Properties",
      image: "/assets/images/sliderImg/Banglore.jpg",
      icon: <FaBuilding />,
      themeClass: "mgh-city-bangalore",
    },
    {
      id: "pune",
      name: "Pune",
      searchParam: "Pune",
      count: "35,000+ Properties",
      image: "/assets/images/sliderImg/Pune.jpg",
      icon: <FaCity />,
      themeClass: "mgh-city-pune",
    },
    {
      id: "chennai",
      name: "Chennai",
      searchParam: "Chennai",
      count: "30,000+ Properties",
      image: "/assets/images/sliderImg/Chennai.jpg",
      icon: <FaSubway />,
      themeClass: "mgh-city-chennai",
    },
    {
      id: "mumbai",
      name: "Mumbai",
      searchParam: "Mumbai",
      count: "72,000+ Properties",
      image: "/assets/images/sliderImg/Mumbai.jpg",
      icon: <FaArchway />,
      themeClass: "mgh-city-mumbai",
    },
    {
      id: "hyderabad",
      name: "Hyderabad",
      searchParam: "Hyderabad",
      count: "26,000+ Properties",
      image: "/assets/images/sliderImg/Hyderabad.jpg",
      icon: <FaMosque />,
      themeClass: "mgh-city-hyderabad",
    },
    {
      id: "kolkata",
      name: "Kolkata",
      searchParam: "Kolkata",
      count: "23,000+ Properties",
      image: "/assets/images/sliderImg/Kolkata.jpg",
      icon: <FaUniversity />,
      themeClass: "mgh-city-kolkata",
    },
  ];

  const handleCityClick = (citySearch) => {
    navigate(`/property-search/Residential/Buy/All/${encodeURIComponent(citySearch)}`);
  };

  return (
    <section className="mgh-cities-section" aria-label="Explore Real Estate in Popular Indian Cities">
      {/* Header Area */}
      <div className="mgh-cities-header">
        <div className="mgh-cities-header-left">
         
          <h2 className="mgh-cities-title">
            Explore Real Estate in <span className="mgh-cities-highlight">Popular Indian Cities</span>
          </h2>
          <p className="mgh-cities-subtitle">
            Find your next home or investment in India's top real estate destinations.
          </p>
        </div>

        {/* Decorative Indian Monuments Skyline Graphic */}
        <div className="mgh-cities-header-right" aria-hidden="true">
          <svg className="mgh-cities-decor-skyline" viewBox="0 0 440 130" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g fill="#c8872b" opacity="0.32">
              <path d="M360 85 C360 65, 375 50, 390 50 C405 50, 420 65, 420 85 L425 85 L425 130 L355 130 L355 85 Z" />
              <path d="M390 35 L392 48 L388 48 Z" />
              <rect x="345" y="60" width="6" height="70" />
              <rect x="429" y="60" width="6" height="70" />
              <path d="M348 50 L352 60 L344 60 Z" />
              <path d="M432 50 L436 60 L428 60 Z" />
              <rect x="250" y="65" width="55" height="65" rx="3" />
              <rect x="265" y="85" width="25" height="45" rx="12" fill="#ffffff" />
              <rect x="180" y="75" width="40" height="55" />
              <rect x="175" y="45" width="6" height="85" />
              <rect x="219" y="45" width="6" height="85" />
              <rect x="110" y="80" width="18" height="50" />
              <rect x="135" y="90" width="22" height="40" />
              <rect x="70" y="95" width="25" height="35" />
            </g>
          </svg>
        </div>
      </div>

      {/* 7 Cities Cards Grid */}
      <div className="mgh-cities-grid">
        {cities.map((city) => (
          <div
            key={city.id}
            className={`mgh-cities-card ${city.themeClass}`}
            onClick={() => handleCityClick(city.searchParam)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                handleCityClick(city.searchParam);
              }
            }}
          >
            {/* Top Landmark Image */}
            <div className="mgh-cities-card-img-wrap">
              <img
                src={city.image}
                alt={city.name}
                className="mgh-cities-card-img"
                loading="lazy"
                onError={(e) => {
                  e.target.src = "/assets/images/sliderImg/Hyderabad.jpg";
                }}
              />
              <div className="mgh-cities-card-overlay"></div>
            </div>

            {/* Card Body */}
            <div className="mgh-cities-card-body">
              <div className="mgh-cities-card-top-row">
                <div className="mgh-cities-icon-circle" aria-hidden="true">
                  {city.icon}
                </div>
                <div className="mgh-cities-arrow-btn" aria-label={`View properties in ${city.name}`}>
                  <FiArrowUpRight className="mgh-cities-arrow-icon" />
                </div>
              </div>

              <h3 className="mgh-cities-card-title" title={city.name}>{city.name}</h3>
              <p className="mgh-cities-card-count">{city.count}</p>
            </div>

            {/* Bottom accent colored bar */}
            <div className="mgh-cities-card-accent"></div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ExploreRealEstate;